import { CssAnimationTimingFunction, CssAnimationVariants, } from '@kubit/web-ui-components/cssAnimation/types';
import { PopoverPositionVariantType, } from '@kubit/web-ui-components/popover/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { POSITIONS } from '@kubit/web-ui-components/types/positions';
import { Z_INDEX } from '../../foundations/zIndex';
import { OverlayVariantType } from '../overlay/variants';
import { PopoverVariantType } from './variants';
const POPOVER_SNACKBAR_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    positionVariant: PopoverPositionVariantType.FIXED,
    align: POSITIONS.BOTTOM_CENTER_FIXED,
    animation: {
        type: CssAnimationVariants.SLIDE_IN,
    },
    margin_bottom: '100px',
    animationOptions: {
        enterDuration: FOUNDATIONS.duration_150,
        exitDuration: FOUNDATIONS.duration_150,
        delay: '0s',
        timingFunction: CssAnimationTimingFunction.EASE_IN_OUT,
        iterationCount: 1,
        opacityStart: 0,
        opacityEnd: 1,
    },
});
export const getPopoverStyles = (FOUNDATIONS, FONT) => {
    return {
        [PopoverVariantType.SNACKBAR_BOTTOM]: {
            zIndex: Z_INDEX.TOAST,
            [DeviceBreakpointsType.DESKTOP]: {
                ...POPOVER_SNACKBAR_COMMON_TOKENS(FOUNDATIONS, FONT),
            },
            [DeviceBreakpointsType.TABLET]: {
                ...POPOVER_SNACKBAR_COMMON_TOKENS(FOUNDATIONS, FONT),
            },
            [DeviceBreakpointsType.MOBILE]: {
                ...POPOVER_SNACKBAR_COMMON_TOKENS(FOUNDATIONS, FONT),
            },
        },
        [PopoverVariantType.SNACKBAR_TOP]: {
            zIndex: Z_INDEX.TOAST,
            [DeviceBreakpointsType.DESKTOP]: {
                ...POPOVER_SNACKBAR_COMMON_TOKENS(FOUNDATIONS, FONT),
                align: POSITIONS.TOP_CENTER_FIXED,
            },
            [DeviceBreakpointsType.TABLET]: {
                ...POPOVER_SNACKBAR_COMMON_TOKENS(FOUNDATIONS, FONT),
                align: POSITIONS.TOP_CENTER_FIXED,
            },
            [DeviceBreakpointsType.MOBILE]: {
                ...POPOVER_SNACKBAR_COMMON_TOKENS(FOUNDATIONS, FONT),
                align: POSITIONS.TOP_CENTER_FIXED,
            },
        },
        [PopoverVariantType.BADGE]: {
            zIndex: Z_INDEX.POPUP,
            [DeviceBreakpointsType.DESKTOP]: {
                positionVariant: PopoverPositionVariantType.ABSOLUTE,
                align: POSITIONS.BOTTOM_CENTER,
            },
            [DeviceBreakpointsType.TABLET]: {
                positionVariant: PopoverPositionVariantType.ABSOLUTE,
                align: POSITIONS.BOTTOM_GAP_RIGHT,
            },
            [DeviceBreakpointsType.MOBILE]: {
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
            },
        },
        [PopoverVariantType.MODAL]: {
            zIndex: Z_INDEX.MODAL,
            [DeviceBreakpointsType.DESKTOP]: {
                overlay: OverlayVariantType.DEFAULT,
            },
            [DeviceBreakpointsType.TABLET]: {
                overlay: OverlayVariantType.DEFAULT,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
            },
            [DeviceBreakpointsType.MOBILE]: {
                overlay: OverlayVariantType.DEFAULT,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
            },
        },
        [PopoverVariantType.TOOLTIP]: {
            zIndex: Z_INDEX.POPUP,
            [DeviceBreakpointsType.DESKTOP]: {
                positionVariant: PopoverPositionVariantType.ABSOLUTE,
            },
            [DeviceBreakpointsType.TABLET]: {
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
                overlay: 'DEFAULT',
                zIndex: Z_INDEX.MODAL,
            },
            [DeviceBreakpointsType.MOBILE]: {
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
                overlay: 'DEFAULT',
                zIndex: Z_INDEX.MODAL,
            },
        },
        [PopoverVariantType.INPUT_SEARCH]: {
            zIndex: Z_INDEX.MODAL,
            [DeviceBreakpointsType.DESKTOP]: {
                positionVariant: PopoverPositionVariantType.ABSOLUTE,
                align: POSITIONS.BOTTOM_CENTER,
                fullWidth: true,
            },
            [DeviceBreakpointsType.TABLET]: {
                overlay: 'DEFAULT',
                align: POSITIONS.BOTTOM_FIXED,
                positionVariant: PopoverPositionVariantType.FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.3,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '100%',
                    animationXStartPosition: '0%',
                    animationYEndPosition: '0%',
                    animationXEndPosition: '0%',
                },
            },
            [DeviceBreakpointsType.MOBILE]: {
                overlay: 'DEFAULT',
                align: POSITIONS.BOTTOM_FIXED,
                positionVariant: PopoverPositionVariantType.FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.3,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '100%',
                    animationXStartPosition: '0%',
                    animationYEndPosition: '0%',
                    animationXEndPosition: '0%',
                },
            },
        },
        [PopoverVariantType.ACTION_BOTTOM_SHEET]: {
            zIndex: Z_INDEX.MODAL,
            [DeviceBreakpointsType.DESKTOP]: {
                positionVariant: PopoverPositionVariantType.ABSOLUTE,
                align: POSITIONS.BOTTOM_LEFT,
            },
            [DeviceBreakpointsType.TABLET]: {
                overlay: 'DEFAULT',
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.3,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '100%',
                    animationXStartPosition: '0%',
                    animationYEndPosition: '0%',
                    animationXEndPosition: '0%',
                },
            },
            [DeviceBreakpointsType.MOBILE]: {
                overlay: 'DEFAULT',
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.3,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '100%',
                    animationXStartPosition: '0%',
                    animationYEndPosition: '0%',
                    animationXEndPosition: '0%',
                },
            },
        },
        [PopoverVariantType.DRAWER_LEFT]: {
            zIndex: Z_INDEX.MODAL,
            [DeviceBreakpointsType.DESKTOP]: {
                overlay: 'DEFAULT',
                positionVariant: 'fixed',
                align: POSITIONS.LEFT_FIXED,
                fullWidth: false,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '0%',
                    animationXStartPosition: '-100%',
                    animationYEndPosition: '0',
                    animationXEndPosition: '0',
                },
            },
            [DeviceBreakpointsType.TABLET]: {
                overlay: 'DEFAULT',
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.RIGHT_FIXED,
                fullWidth: false,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '0%',
                    animationXStartPosition: '-100%',
                    animationYEndPosition: '0',
                    animationXEndPosition: '0',
                },
            },
            [DeviceBreakpointsType.MOBILE]: {
                overlay: 'DEFAULT',
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.RIGHT_FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '0%',
                    animationXStartPosition: '-100%',
                    animationYEndPosition: '0',
                    animationXEndPosition: '0',
                },
            },
        },
        [PopoverVariantType.DRAWER_RIGHT]: {
            zIndex: Z_INDEX.MODAL,
            [DeviceBreakpointsType.DESKTOP]: {
                overlay: 'DEFAULT',
                positionVariant: 'fixed',
                align: POSITIONS.RIGHT_FIXED,
                fullWidth: false,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '0%',
                    animationXStartPosition: '100%',
                    animationYEndPosition: '0',
                    animationXEndPosition: '0',
                },
            },
            [DeviceBreakpointsType.TABLET]: {
                overlay: 'DEFAULT',
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.RIGHT_FIXED,
                fullWidth: false,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '0%',
                    animationXStartPosition: '100%',
                    animationYEndPosition: '0',
                    animationXEndPosition: '0',
                },
            },
            [DeviceBreakpointsType.MOBILE]: {
                overlay: 'DEFAULT',
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.RIGHT_FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '0%',
                    animationXStartPosition: '100%',
                    animationYEndPosition: '0',
                    animationXEndPosition: '0',
                },
            },
        },
        [PopoverVariantType.DRAWER_BOTTOM]: {
            zIndex: Z_INDEX.MODAL,
            [DeviceBreakpointsType.DESKTOP]: {
                positionVariant: 'relative',
                align: POSITIONS.RIGHT_FIXED,
                fullWidth: false,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '0%',
                    animationXStartPosition: '100%',
                    animationYEndPosition: '0',
                    animationXEndPosition: '0',
                },
            },
            [DeviceBreakpointsType.TABLET]: {
                overlay: 'DEFAULT',
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '100%',
                    animationXStartPosition: '0',
                    animationYEndPosition: '0%',
                    animationXEndPosition: '0',
                },
            },
            [DeviceBreakpointsType.MOBILE]: {
                overlay: 'DEFAULT',
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.BOTTOM_FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.5,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '100%',
                    animationXStartPosition: '0',
                    animationYEndPosition: '0%',
                    animationXEndPosition: '0',
                },
            },
        },
        [PopoverVariantType.INPUT_DATE]: {
            zIndex: Z_INDEX.MODAL,
            [DeviceBreakpointsType.DESKTOP]: {
                overlay: OverlayVariantType.DEFAULT,
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.CENTER,
            },
            [DeviceBreakpointsType.TABLET]: {
                overlay: OverlayVariantType.DEFAULT,
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.CENTER,
                fullWidth: true,
            },
            [DeviceBreakpointsType.MOBILE]: {
                overlay: OverlayVariantType.DEFAULT,
                positionVariant: PopoverPositionVariantType.FIXED,
                align: POSITIONS.TOP_CENTER_FIXED,
                fullWidth: true,
            },
        },
        [PopoverVariantType.SELECT_CONTEXT_MENU]: {
            zIndex: Z_INDEX.POPUP,
            [DeviceBreakpointsType.DESKTOP]: {
                positionVariant: PopoverPositionVariantType.ABSOLUTE,
            },
        },
        [PopoverVariantType.DROPDOWN_MULTISELECT]: {
            zIndex: Z_INDEX.MODAL,
            [DeviceBreakpointsType.DESKTOP]: {
                positionVariant: PopoverPositionVariantType.ABSOLUTE,
                align: POSITIONS.BOTTOM_CENTER,
                fullWidth: true,
            },
            [DeviceBreakpointsType.TABLET]: {
                overlay: 'DEFAULT',
                align: POSITIONS.BOTTOM_FIXED,
                positionVariant: PopoverPositionVariantType.FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.3,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '100%',
                    animationXStartPosition: '0%',
                    animationYEndPosition: '0%',
                    animationXEndPosition: '0%',
                },
            },
            [DeviceBreakpointsType.MOBILE]: {
                overlay: 'DEFAULT',
                align: POSITIONS.BOTTOM_FIXED,
                positionVariant: PopoverPositionVariantType.FIXED,
                fullWidth: true,
                animation: {
                    type: CssAnimationVariants.SLIDE_IN,
                },
                animationOptions: {
                    duration: 0.3,
                    delay: 0,
                    timingFunction: CssAnimationTimingFunction.LINEAR,
                    iterationCount: 1,
                    animationDistanceInPx: 100,
                    animationRotationInDeg: 500,
                    animationYStartPosition: '100%',
                    animationXStartPosition: '0%',
                    animationYEndPosition: '0%',
                    animationXEndPosition: '0%',
                },
            },
        },
    };
};
//# sourceMappingURL=styles.js.map